var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIModifyOn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.4552 16.781L3.5203 17.1454C3.22958 17.1998 2.9693 16.958 3.00294 16.6641L3.23919 14.5954C3.26963 14.3287 3.38976 14.0805 3.57876 13.8915L14.2159 3.2543C14.5563 2.91393 15.1073 2.91393 15.4476 3.2543L16.7451 4.55171C17.0854 4.89208 17.0854 5.44308 16.7451 5.78345L6.07427 16.4534C5.90529 16.6224 5.68986 16.7361 5.4552 16.7802V16.781Z",
    fill: "#1065D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0003 17.2612H7.95605V16.0612H17.0003V17.2612Z",
    fill: "#1065D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIModifyOn);
export default __webpack_public_path__ + "static/media/i_modify_on.830c9b0fd9257ba3428426f506a056e0.svg";
export { ForwardRef as ReactComponent };